const zooms = [
  '50%',
  '75%',
  '100%',
  '125%',
  '150%',
  '200%'
].map(text => {
  return {
    text,
    value: text
  }
})

export default zooms



// WEBPACK FOOTER //
// ./src/helpers/device-emulator-zooms.js